import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-schoolmanage",
  "use": "icon-schoolmanage-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-schoolmanage\"><defs><style type=\"text/css\"></style></defs><path d=\"M1024 452.8H0v-104.64l16.96-9.6L474.56 96h73.92L1024 346.56z m-960-64h896V384L532.8 160h-42.24L64 386.24zM0 960h1024v64H0z\" p-id=\"3237\" /><path d=\"M1011.52 192H704V0h306.24l-45.12 96zM768 128h140.8l-15.04-32 16-32H768z\" p-id=\"3238\" /><path d=\"M704.32 128h64v96h-64zM64.64 512h64v480h-64zM896.64 512h64v480h-64zM640 992h-64v-128a64 64 0 0 0-128 0v128h-64v-128a128 128 0 0 1 256 0zM192.64 768h64v64h-64zM192.64 640h64v64h-64zM768.96 768h64v64h-64zM768.96 640h64v64h-64zM576.64 640h64v64h-64zM384.64 640h64v64h-64zM192.64 512h64v64h-64zM768.96 512h64v64h-64zM576.64 512h64v64h-64zM384.64 512h64v64h-64z\" p-id=\"3239\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/schoolmanage.svg
// module id = JX5u
// module chunks = 60